/**
 * Compares two 2-dimensional arrays for equality.
 * Two arrays are considered equal if they have the same dimensions
 * and all corresponding elements are strictly equal.
 *
 * @param {Array} a The first 2-dimensional array to compare.
 * @param {Array} b The second 2-dimensional array to compare.
 * @return {boolean} Returns true if the arrays are equal, otherwise false.
 */
export default function arraysEqual(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every(
      (innerA, i) =>
        Array.isArray(innerA) &&
        Array.isArray(b[i]) &&
        innerA.length === b[i].length &&
        innerA.every((val, j) => val === b[i][j])
    )
  );
}
